import { useState, useEffect } from "react";
import { loadRequestIndentNumberlist } from "../services/requestIndentService";
import { loadIssuedIndentNumberListOnReturn } from "../services/returnIndentServise";



const UseIssuedIndentNumberListOnReturn = () => {
    const [issuedNumberList, setIssuedIndentNumberList] = useState([]);
    const [selectedIssuedIndentNumberList, setSelectedIssuedIndentNumberList] = useState([]);
    const [selectedIssuedIndentNumberListID, setSelectedIssuedIndentNumberListID] = useState([]);
    const [isShiftRoasterDataLoaded, setIsShiftRoasterDataLoaded] = useState(false);



    const fetchIssuedNumberList = async (selectedID = null) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
        };
        try {
            const data = await loadIssuedIndentNumberListOnReturn(para);
            if (data && data.length > 0) {
                setIssuedIndentNumberList(data);

                const initialDepartment = data.find((dept) => dept.id === selectedID);

                if (initialDepartment) { // ✅ Corrected check
                    setSelectedIssuedIndentNumberList(initialDepartment);
                    setSelectedIssuedIndentNumberListID(initialDepartment.id);
                    setIsShiftRoasterDataLoaded(true);
                }
            }
            else {
                setIssuedIndentNumberList([]);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isShiftRoasterDataLoaded) {
            fetchIssuedNumberList();
        }
    }, [isShiftRoasterDataLoaded]);

    // Function to load department based on selected ID 

    const loadIssuedIndentNumbersByID = async (selectedID) => {
        await fetchIssuedNumberList(selectedID);
    };

    return {
        issuedNumberList,
        selectedIssuedIndentNumberList,
        selectedIssuedIndentNumberListID,
        setSelectedIssuedIndentNumberList,
        setSelectedIssuedIndentNumberListID,
        loadIssuedIndentNumbersByID,
    };
};

export default UseIssuedIndentNumberListOnReturn;